import { ReactNode } from "react";
import { Card } from "shared/components/Card";

export const StatusCard = ({
  variant,
  icon,
  title,
  subtitle
}: {
  variant: "badge" | "banner";
  icon: ReactNode;
  title: string;
  subtitle?: ReactNode;
}) => {
  if (variant === "banner")
    return (
      <Card className="w-[300px] min-h-[274px] flex flex-col shrink-0 h-full">
        <div className="flex flex-grow items-center justify-center bg-primary-20 border-b border-alpha-40 py-6">
          {icon}
        </div>

        <div className="p-6 flex flex-col items-center justify-center gap-2">
          <p className="font-bold text-base text-content-1000 text-center">
            {title}
          </p>
          {subtitle ? (
            <p className="text-content-400 font-medium text-xs text-center">
              {subtitle}
            </p>
          ) : null}
        </div>
      </Card>
    );

  return (
    <Card className="w-[300px] min-h-[274px] p-6 flex flex-col items-center justify-center shrink-0 h-full">
      <div className="h-[100px] w-[100px] flex items-center justify-center rounded-full bg-alpha-20">
        {icon}
      </div>

      <h2 className="text-base text-content-500 font-bold mt-6 mb-2 text-center">
        {title}
      </h2>

      <p className="text-sm text-content-300 font-medium text-center">
        {subtitle}
      </p>
    </Card>
  );
};
